module.exports = __webpack_public_path__ + "img/divider.92da38f1.svg";